export default "__VITE_ASSET__6i027Qk6__"